export const brandImages = [
  { id: 1, src: "/assets/images/brands/brand1.png", width: 120, height: 20 },
  { id: 2, src: "/assets/images/brands/brand2.png", width: 87, height: 20 },
  { id: 3, src: "/assets/images/brands/brand3.png", width: 132, height: 22 },
  { id: 4, src: "/assets/images/brands/brand4.png", width: 72, height: 21 },
  { id: 5, src: "/assets/images/brands/brand5.png", width: 123, height: 31 },
  { id: 6, src: "/assets/images/brands/brand6.png", width: 137, height: 22 },
  { id: 7, src: "/assets/images/brands/brand7.png", width: 94, height: 21 },
   { id: 1, src: "/assets/images/brands/brand1.png", width: 120, height: 20 },
  { id: 2, src: "/assets/images/brands/brand2.png", width: 87, height: 20 },
  { id: 3, src: "/assets/images/brands/brand3.png", width: 132, height: 22 },
  { id: 4, src: "/assets/images/brands/brand4.png", width: 72, height: 21 },
  { id: 5, src: "/assets/images/brands/brand5.png", width: 123, height: 31 },
  { id: 6, src: "/assets/images/brands/brand6.png", width: 137, height: 22 },
  { id: 7, src: "/assets/images/brands/brand7.png", width: 94, height: 21 },
];
export const brandImages2 = [
  { id: 1, src: "/assets/images/brands/brand1.png", width: 120, height: 20 },
  { id: 2, src: "/assets/images/brands/brand2.png", width: 87, height: 20 },
  { id: 3, src: "/assets/images/brands/brand3.png", width: 132, height: 22 },
  { id: 4, src: "/assets/images/brands/brand4.png", width: 72, height: 21 },
  { id: 5, src: "/assets/images/brands/brand5.png", width: 123, height: 31 },
  { id: 6, src: "/assets/images/brands/brand6.png", width: 137, height: 22 },
  { id: 7, src: "/assets/images/brands/brand7.png", width: 94, height: 21 },
  { id: 1, src: "/assets/images/brands/brand1.png", width: 120, height: 20 },
  { id: 2, src: "/assets/images/brands/brand2.png", width: 87, height: 20 },
  { id: 3, src: "/assets/images/brands/brand3.png", width: 132, height: 22 },
  { id: 4, src: "/assets/images/brands/brand4.png", width: 72, height: 21 },
  { id: 5, src: "/assets/images/brands/brand5.png", width: 123, height: 31 },
  { id: 6, src: "/assets/images/brands/brand6.png", width: 137, height: 22 },
  { id: 7, src: "/assets/images/brands/brand7.png", width: 94, height: 21 },
];
